<template>
  <v-tooltip v-if="inconsistencies.length > 0" bottom>
    <template v-slot:activator="{ on }">
      <v-icon :color="iconColor" :small="small" class="ml-1" v-on="on">
        {{ icon }}
      </v-icon>
    </template>
    <span>
      Inconsistências encontradas:
    </span>
    <ul>
      <li v-for="(inconsistency, index) in inconsistencies" :key="index">
        {{ inconsistency }}
      </li>
    </ul>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    inconsistencies: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: "mdi-alert-circle",
    },
    iconColor: {
      type: String,
      default: "warning",
    },
    small: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
